import tokens from '@lansforsakringar/core-tokens'
import { css } from 'lit'

import { vars, scoped, declare, override } from '#utils/styles'

const locals = scoped('shortcut', [
	'background_color',
	'border_color',
	'color'
] as const)

export default css`
	:host {
		${declare(locals, {
			background_color: tokens.color_background_secondary,
			border_color: tokens.color_border_secondary,
			color: tokens.color_text_primary
		})};

		min-width: 100%;
		display: block;

		&:has(.input:disabled) {
			${override(locals.color, tokens.color_text_disabled)};
		}
	}

	a.shortcut {
		text-decoration-line: none;
	}

	.shortcut {
		display: flex;
		align-items: center;
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		gap: ${vars(tokens.spacing_md)};
		position: relative;
		cursor: pointer;
		border: 1px solid ${vars(locals.border_color)};
		background: ${vars(locals.background_color)};
		border-radius: ${vars(tokens.border_radius_sm)};
		padding-block: ${vars(tokens.spacing_md)};
		padding-inline: ${vars(tokens.spacing_lg)};
		transition: 100ms var(--ease-in);
		transition-property: box-shadow, border-color;
		text-align: start;
		text-wrap: balance;

		&:focus-visible,
		&:hover {
			${override(locals.border_color, tokens.color_border_selected)};

			box-shadow: inset 0 0 0 1px ${vars(locals.border_color)};
			transition-timing-function: var(--ease-out);
		}

		&.vertical {
			flex-direction: column;
			align-items: center;
			text-align: center;
			padding-block: 1.25rem;
		}

		&:focus {
			outline: 0;
		}

		&.focus-visible:focus-visible {
			outline: var(--focus-outline);
			outline-offset: var(--focus-outline-offset);
		}
	}

	.shortcut.vertical .icon {
		transition: transform 125ms var(--ease-in-out);
		will-change: transform;
	}

	.shortcut.vertical:focus-visible .icon,
	.shortcut.vertical:hover .icon {
		transform: translateY(-0.2rem);
	}

	.label {
		display: block;
		font-size: 1.125rem;
		font-weight: 600;
		line-height: calc(19 / 16);
		color: ${vars(tokens.color_text_brand_primary)};
	}

	.description:not(:empty) {
		display: block;
		margin-block-start: ${vars(tokens.spacing_xs)};
		font-size: 0.875rem;
		font-weight: normal;
		line-height: calc(18 / 14);
		max-height: calc(2em * (18 / 14));
		overflow: hidden;
		color: ${vars(tokens.color_text_secondary)};
	}

	.content {
		flex-grow: 1;
	}

	.arrow {
		flex-shrink: 0;
		transition: transform 125ms var(--ease-in);
		will-change: transform;
	}

	.shortcut.vertical .arrow {
		display: none;
	}

	.shortcut:focus-visible .arrow,
	.shortcut:hover .arrow {
		transform: translateX(0.25rem);
		transition-timing-function: var(--ease-out);
	}
`
